import { connect } from "react-redux";

import { getFullReportList } from "actions/full_report";
import FullReportPage from "./FullReportPage";
import { getReferencesForReports } from "actions/references";
import { getAccountManagersBillingList, getAccountManagersDropdownList } from "actions/account_managers";

// getAccountManagersBillingList, getAccountManagersDropdownList 
// getReferencesForReports

// reasonList, accountManagerList, accountManagerBilList, countryList, 
// originatorList, subdestinationList, supplierList, servicePlanList, dialerList

const mapStateToProps = ({ full_report, auth, references, account_managers }) => ({
    data: full_report.list,
    count: full_report.count,
    loading: full_report.loading,
    page: full_report.page,

    originatorList: references.client_list,
    reasonList: references["sms.reason_list"],
    dialerList: auth.service ? references.dialer_list : references["sms.dialer_list"],
    supplierList: auth.service ? references.supplier_list : references["sms.supplier_list"],
    servicePlanList: references.service_plan_list,
    countryList: references.country_list,
    accountManagerBilList: account_managers.billingList,
    accountManagerList: account_managers.dropdown_list,
    subdestinationList: references.subdestination_list,

    service: auth.service,
    globalSettings: references.global_setting,
});

export default connect(mapStateToProps, {
    getData: getFullReportList,

    getReferencesForReports,

    getAccountManagersBillingList,
    getAccountManagersDropdownList
})(FullReportPage);